import { ComponentItem } from "designSystem/types/component-item-types";
import { getPinyin } from "src/c8-platform/service/languageService";

/** generate the pinyin code */
export function generatePinyinCode<T extends ComponentItem>(options: T[]): void {
	options.forEach((option) => {
		const { name, name2 } = option;
		let pinyinCode = "";

		if (name2) {
			pinyinCode = getPinyin(`${name} ${name2}`);
		} else {
			pinyinCode = getPinyin(name);
		}

		// include the original text as well so that we can search by both patterns
		option.pinyinCode = `${pinyinCode}${name}${name2}`;
	});
}